import { useLazyQuery } from "@apollo/client";
import {
  Container,
  Grid,
  InputGroup,
  Loading,
  Typography,
} from "@pmberjaya/cloudbank-ui";
import { useRouter } from "next/router";
import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { USER_INFO } from "../../../gql/user";

const RequiredLogin = (props) => {
  const router = useRouter();
  const [loadUserData, { loading, error }] = useLazyQuery(USER_INFO);
  const [cookie] = useCookies();
  useEffect(() => {
    if (typeof cookie.access_token !== "undefined") {
      loadUserData();
    }
    // eslint-disable-next-line
  }, [cookie]);

  if (error || typeof cookie.access_token === "undefined") {
    window.open(
      `${process.env.REACT_APP_NEW_DOMAIN}login?continue=${window.location.href}`,
      "_self"
    );
  }
  if (loading) {
    return (
      <Container>
        <Grid>
          <InputGroup>
            <Loading />
            <Typography variant="h5">Get User Information</Typography>
          </InputGroup>
        </Grid>
      </Container>
    );
  }
  return props.children;
};

export default RequiredLogin;
